import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';
import { MustMatch } from 'src/app/shared/_helpers/must-match-validation';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  public authKey:string = this.route.snapshot.queryParamMap.get('key');
  public email:string = this.route.snapshot.queryParamMap.get('email');
  public changePasswordForm:FormGroup;
  public message:string="";
  public isShowMsg:boolean = false;

  constructor(
    private route: ActivatedRoute,
    private fb:FormBuilder,
    private authenticationService:AuthenticationService) { }
  
  ngOnInit(): void {
    this.createChangePasswordForm();
    this.checkValidLinkOrNot();
  }

  checkValidLinkOrNot():void{
    var params = {
      'auth_key':this.authKey,
      'email': this.email,
    }

    this.authenticationService.checkResetPasswordLinkValidOrNot(params).subscribe(
      (res:any) => {
        if(res.status == 'error'){
          this.message = res.message;
        }else{
          this.isShowMsg = true;
        }
      }
    )
  }

  createChangePasswordForm():void{
    this.changePasswordForm = this.fb.group({
      'new_password': ['',[Validators.required,Validators.minLength(8)]],
      'confirm_new_password': [''],
      'auth_key':[this.authKey],
      'email': [this.email],
    },{
       validators:MustMatch('new_password','confirm_new_password')
    });
  }

  get changePasswordFormValidate(){ return this.changePasswordForm.controls; }

  changePasswordFormSubmit():void{

    if(!this.changePasswordForm.valid){
      return;
    }

    this.authenticationService.resetPassword(this.changePasswordForm.value).subscribe(
      (res:any)=>{
        if(res.status == 'success'){
          this.message = res.message;
          this.isShowMsg = false;
        }

        if(res.status == 'error'){
          this.message = res.message;
          this.isShowMsg = true;
        }
      },
      (err)=> {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong! Please try again later.',
        });
      }
    )
   
  }





}
